<template>
    <div>
        <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">

            <c-panel title="IDENTIFICAÇÃO" titleIcon="fas fa-id-card">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Aluno" prop="aluno_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.aluno_id"
                                       filterable remote :remote-method="searchAluno"
                                       :loading="loadingAluno" clearable
                                       placeholder="Digite o nome do aluno...">
                                <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Ano" prop="ano" :rules="[$requiredBlur]">
                            <el-input v-model="dados.ano" v-mask="'####'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Data">
                            <el-input v-model="dados.data" v-mask="'##/##/####'" placeholder="dd/mm/aaaa"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Horário">
                            <el-input v-model="dados.horario" v-mask="'##:##'" placeholder="hh:mm"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Professor do AEE (servidor)">
                            <el-select v-model="dados.professor_aee_servidor_id"
                                       filterable remote :remote-method="searchServidor"
                                       :loading="loadingServidor" clearable
                                       placeholder="Digite o nome do servidor...">
                                <el-option v-for="s in servidores" :key="s.id" :label="s.nome" :value="s.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Modalidade">
                            <el-radio-group v-model="dadosForm.modalidade">
                                <el-radio v-for="o in $CONSTANTS.AEE_MODALIDADES" :key="o.v" :label="o.v">{{ o.l }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Dia da semana">
                            <el-checkbox-group v-model="dadosForm.dia_semana">
                                <el-checkbox v-for="o in $CONSTANTS.AEE_DIAS_SEMANA" :key="o.v" :label="o.v">{{ o.l }}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="1. POTENCIALIDADES A FORTALECER (NEE)" titleIcon="fas fa-bullseye">
                <el-checkbox-group v-model="dadosForm.potencialidades">
                    <el-checkbox v-for="o in $CONSTANTS.AEE_POTENCIALIDADES" :key="o.v" :label="o.v" style="margin-bottom: 6px;">{{ o.l }}</el-checkbox>
                </el-checkbox-group>
                <el-input v-if="(dadosForm.potencialidades || []).indexOf('outros') >= 0" v-model="dadosForm.potencialidades_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
            </c-panel>

            <c-panel title="2. ESTRATÉGIAS METODOLÓGICAS" titleIcon="fas fa-list-ul">
                <el-checkbox-group v-model="dadosForm.estrategias">
                    <el-checkbox v-for="o in $CONSTANTS.AEE_ESTRATEGIAS" :key="o.v" :label="o.v" style="margin-bottom: 6px;">{{ o.l }}</el-checkbox>
                </el-checkbox-group>
                <el-input v-if="(dadosForm.estrategias || []).indexOf('outros') >= 0" v-model="dadosForm.estrategias_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
            </c-panel>

            <c-panel title="ATIVIDADES POR SEMANA" titleIcon="fas fa-calendar-week">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" v-for="n in [1,2,3,4]" :key="n">
                        <el-form-item :label="n + 'ª semana'">
                            <el-input type="textarea" :rows="3" v-model="dadosForm.atividades_semanais['semana' + n]"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel v-for="(opcoes, chave) in $CONSTANTS.AEE_CATEGORIAS" :key="chave" :title="rotuloCategoria(chave)" titleIcon="fas fa-th-large">
                <el-checkbox-group v-model="categorias[chave]">
                    <el-checkbox v-for="o in opcoes" :key="o.v" :label="o.v" style="margin-bottom: 6px;">{{ o.l }}</el-checkbox>
                </el-checkbox-group>
                <el-input v-if="(categorias[chave] || []).indexOf('outros') >= 0" v-model="categoriasOutro[chave]" placeholder="Especificar..." class="u-mt-5"></el-input>
            </c-panel>

            <c-panel title="3. RECURSOS" titleIcon="fas fa-toolbox">
                <h4 style="margin-top: 4px;">Tecnologia</h4>
                <el-checkbox-group v-model="recursos.tecnologia">
                    <el-checkbox v-for="o in $CONSTANTS.AEE_RECURSOS.tecnologia" :key="o.v" :label="o.v" style="margin-bottom: 6px;">{{ o.l }}</el-checkbox>
                </el-checkbox-group>
                <el-input v-if="(recursos.tecnologia || []).indexOf('outros') >= 0" v-model="recursosOutro.tecnologia" placeholder="Especificar..." class="u-mt-5"></el-input>
                <h4 style="margin-top: 14px;">Diversos</h4>
                <el-checkbox-group v-model="recursos.diversos">
                    <el-checkbox v-for="o in $CONSTANTS.AEE_RECURSOS.diversos" :key="o.v" :label="o.v" style="margin-bottom: 6px;">{{ o.l }}</el-checkbox>
                </el-checkbox-group>
                <el-input v-if="(recursos.diversos || []).indexOf('outros') >= 0" v-model="recursosOutro.diversos" placeholder="Especificar..." class="u-mt-5"></el-input>
            </c-panel>

            <c-panel title="4 e 5. AVALIAÇÃO E OBSERVAÇÕES" titleIcon="fas fa-clipboard-check">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Desempenho">
                            <el-select v-model="dadosForm.desempenho" clearable>
                                <el-option v-for="o in $CONSTANTS.AEE_DESEMPENHOS" :key="o.v" :label="o.l" :value="o.v"></el-option>
                            </el-select>
                            <el-input v-if="dadosForm.desempenho === 'outros'" v-model="dadosForm.desempenho_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Observações">
                            <el-input type="textarea" :rows="4" v-model="dadosForm.observacoes"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <el-row :gutter="10" class="u-mt-10">
                <el-col :xs="24" :sm="12">
                    <el-form-item>
                        <el-checkbox v-model="dados.finalizado">Marcar como finalizado</el-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" class="u-text-right">
                    <el-button v-if="dados.id" type="primary" @click="imprimir">IMPRIMIR</el-button>
                    <el-button class="u-ml-10" type="primary" id="btn-aee" native-type="submit">SALVAR</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
const ROTULOS_CATEGORIA = {
    texturas: 'MANIPULAÇÃO DE TEXTURAS',
    avd: "2.1 AVD's",
    jogos: '2.2 JOGOS PEDAGÓGICOS',
    motricidade_fina: '2.3 MOTRICIDADE FINA',
    motricidade_ampla: '2.4 MOTRICIDADE AMPLA',
    pintura: '2.5 TÉCNICAS DE PINTURA'
}

export default {
    props: ['paramId'],
    data: () => ({
        edit: false,
        loadingAluno: false,
        loadingServidor: false,
        alunos: [],
        servidores: [],
        dados: {
            id: '',
            aluno_id: '',
            instituicao_id: null,
            ano: new Date().getFullYear(),
            periodo_letivo_id: null,
            professor_aee_servidor_id: null,
            data: '',
            horario: '',
            data_preenchimento: '',
            finalizado: false
        },
        dadosForm: {
            dia_semana: [],
            modalidade: '',
            potencialidades: [],
            potencialidades_outro: '',
            estrategias: [],
            estrategias_outro: '',
            atividades_semanais: { semana1: '', semana2: '', semana3: '', semana4: '' },
            desempenho: '',
            desempenho_outro: '',
            observacoes: ''
        },
        categorias: {
            texturas: [], avd: [], jogos: [],
            motricidade_fina: [], motricidade_ampla: [], pintura: []
        },
        categoriasOutro: {
            texturas: '', avd: '', jogos: '',
            motricidade_fina: '', motricidade_ampla: '', pintura: ''
        },
        recursos: { tecnologia: [], diversos: [] },
        recursosOutro: { tecnologia: '', diversos: '' }
    }),
    methods: {
        rotuloCategoria (chave) { return ROTULOS_CATEGORIA[chave] || chave },
        searchAluno (query) {
            if (!query) { this.alunos = []; return }
            this.loadingAluno = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/aluno/searchByNome`,
                { query: query },
                this.$store.getters.getHeaderAuth
            ).then(response => { this.alunos = response.data || [] })
              .catch(() => {}).finally(() => { this.loadingAluno = false })
        },
        searchServidor (query) {
            if (!query) { this.servidores = []; return }
            this.loadingServidor = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`,
                { query: query },
                this.$store.getters.getHeaderAuth
            ).then(response => { this.servidores = response.data || [] })
              .catch(() => {}).finally(() => { this.loadingServidor = false })
        },
        getById (id) {
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/plano-aee/getById/` + id, this.$store.getters.getHeaderAuth)
                .then(response => {
                    const r = response.data || {}
                    this.dados = Object.assign({}, this.dados, {
                        id: r.id, aluno_id: r.aluno_id, instituicao_id: r.instituicao_id,
                        ano: r.ano, periodo_letivo_id: r.periodo_letivo_id,
                        professor_aee_servidor_id: r.professor_aee_servidor_id,
                        data: r.data ? this.$moment(r.data).format('DD/MM/YYYY') : '',
                        horario: r.horario ? String(r.horario).substring(0, 5) : '',
                        data_preenchimento: r.data_preenchimento ? this.$moment(r.data_preenchimento).format('DD/MM/YYYY') : '',
                        finalizado: !!r.finalizado
                    })
                    if (r.aluno) this.alunos = [r.aluno]
                    if (r.professor_aee) this.servidores = [r.professor_aee]
                    const d = r.dados || {}
                    this.dadosForm = Object.assign({
                        dia_semana: [], modalidade: '', potencialidades: [], potencialidades_outro: '',
                        estrategias: [], estrategias_outro: '',
                        atividades_semanais: { semana1: '', semana2: '', semana3: '', semana4: '' },
                        desempenho: '', desempenho_outro: '', observacoes: ''
                    }, {
                        dia_semana: d.dia_semana || [],
                        modalidade: d.modalidade || '',
                        potencialidades: d.potencialidades || [],
                        potencialidades_outro: d.potencialidades_outro || '',
                        estrategias: d.estrategias || [],
                        estrategias_outro: d.estrategias_outro || '',
                        atividades_semanais: Object.assign({ semana1: '', semana2: '', semana3: '', semana4: '' }, d.atividades_semanais || {}),
                        desempenho: d.desempenho || '',
                        desempenho_outro: d.desempenho_outro || '',
                        observacoes: d.observacoes || ''
                    })
                    const cat = d.categorias || {}
                    this.categorias = {
                        texturas: cat.texturas || [], avd: cat.avd || [], jogos: cat.jogos || [],
                        motricidade_fina: cat.motricidade_fina || [], motricidade_ampla: cat.motricidade_ampla || [], pintura: cat.pintura || []
                    }
                    const catOutro = d.categorias_outro || {}
                    this.categoriasOutro = {
                        texturas: catOutro.texturas || '', avd: catOutro.avd || '', jogos: catOutro.jogos || '',
                        motricidade_fina: catOutro.motricidade_fina || '', motricidade_ampla: catOutro.motricidade_ampla || '', pintura: catOutro.pintura || ''
                    }
                    const rec = d.recursos || {}
                    this.recursos = { tecnologia: rec.tecnologia || [], diversos: rec.diversos || [] }
                    const recOutro = d.recursos_outro || {}
                    this.recursosOutro = { tecnologia: recOutro.tecnologia || '', diversos: recOutro.diversos || '' }
                }).catch((error) => { this.$store.commit('throwException', error) })
                .finally(() => { window.eventBus.$emit('loading', false) })
        },
        buildPayload () {
            const inst = this.$store.state.config && this.$store.state.config.instituicao ? this.$store.state.config.instituicao : null
            const data = this.dados.data && this.$moment(this.dados.data, 'DD/MM/YYYY', true).isValid()
                ? this.$moment(this.dados.data, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
            const dataPreench = this.dados.data_preenchimento && this.$moment(this.dados.data_preenchimento, 'DD/MM/YYYY', true).isValid()
                ? this.$moment(this.dados.data_preenchimento, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
            return {
                aluno_id: this.dados.aluno_id,
                instituicao_id: inst ? inst.id : this.dados.instituicao_id,
                ano: parseInt(this.dados.ano) || new Date().getFullYear(),
                periodo_letivo_id: this.dados.periodo_letivo_id,
                professor_aee_servidor_id: this.dados.professor_aee_servidor_id,
                data: data,
                horario: this.dados.horario || null,
                data_preenchimento: dataPreench,
                finalizado: !!this.dados.finalizado,
                dados: {
                    dia_semana: this.dadosForm.dia_semana,
                    modalidade: this.dadosForm.modalidade,
                    potencialidades: this.dadosForm.potencialidades,
                    potencialidades_outro: this.dadosForm.potencialidades_outro,
                    estrategias: this.dadosForm.estrategias,
                    estrategias_outro: this.dadosForm.estrategias_outro,
                    atividades_semanais: this.dadosForm.atividades_semanais,
                    categorias: this.categorias,
                    categorias_outro: this.categoriasOutro,
                    recursos: this.recursos,
                    recursos_outro: this.recursosOutro,
                    desempenho: this.dadosForm.desempenho,
                    desempenho_outro: this.dadosForm.desempenho_outro,
                    observacoes: this.dadosForm.observacoes
                }
            }
        },
        onSubmit () {
            document.getElementById('btn-aee').focus()
            this.$refs.dados.validate((valid) => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const payload = this.buildPayload()
                const url = this.edit
                    ? `${this.$store.state.config.baseUrlApi}/api/plano-aee/update/` + this.dados.id
                    : `${this.$store.state.config.baseUrlApi}/api/plano-aee/store`
                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth)
                    .then(response => {
                        window.eventBus.$emit('loading', false)
                        if (response.data && response.data.erro) {
                            const t = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Erro ao salvar.')
                            window.eventBus.$emit('alert', { msg: t, type: 'warning' })
                            return
                        }
                        window.eventBus.$emit('alert', { msg: 'AEE/PAD salvo com sucesso.', type: 'success' })
                        this.$emit('onSubmit')
                    })
                    .catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
            })
        },
        imprimir () {
            if (!this.dados.id) return
            window.eventBus.$emit('loading', true)
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/plano-aee/imprimir/${this.dados.id}`,
                this.$store.getters.getHeaderAuthExcel
            ).then(response => {
                window.eventBus.$emit('loading', false)
                const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.target = '_blank'
                link.click()
                window.URL.revokeObjectURL(link.href)
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {
                if (value) {
                    this.edit = true
                    this.getById(value)
                }
            }
        }
    }
}
</script>
